module.exports = __webpack_public_path__ + "img/pulsegenerator.5fc56f6c.svg";